module.exports = __webpack_public_path__ + "static/media/landscape.1.887599b2.jpg";